import { render, staticRenderFns } from "./TestsList.vue?vue&type=template&id=6944767b&scoped=true&"
import script from "./TestsList.vue?vue&type=script&lang=js&"
export * from "./TestsList.vue?vue&type=script&lang=js&"
import style0 from "./TestsList.vue?vue&type=style&index=0&id=6944767b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6944767b",
  null
  
)

export default component.exports